module.exports = __webpack_public_path__ + "images/18c74fd3e1ccb2a3f8361606314b47e4.png";